import { forwardRef } from 'react';
import { Typography } from '../typography';
import { Props } from './types';
import { levelPresets } from './model';

export const Layout = forwardRef<HTMLElement, Props>(function Component(
  { level = 1, Component = 'span', normalize = true, ...props },
  forwardedRef
) {
  return (
    <Typography
      {...props}
      baseClassName={levelPresets[level]}
      Component={Component}
      normalize={normalize}
      ref={forwardedRef}
    />
  );
});
